/* The calendar's one query — STORY-014.
 *
 * One request per month, matching one server read. Two requests — Events from
 * one, Tasks from another — can show a Task on a day whose Event was already
 * deleted, and this is the screen people open to find out what is coming.
 */

import { calendarResponseSchema } from '@eventuley/contracts';
import { useQuery } from '@tanstack/react-query';
import { request } from '../../../shared/api/client.js';

export const calendarKey = (organisationId: string, month: string) =>
  ['organisations', organisationId, 'calendar', month] as const;

export function useCalendarMonth(organisationId: string, month: string) {
  return useQuery({
    queryKey: calendarKey(organisationId, month),
    queryFn: () =>
      request(`/organisations/${organisationId}/calendar?month=${month}`, {
        schema: calendarResponseSchema,
      }),
    /* The previous month stays while the next loads, so paging through months
     * does not blank the grid under the reader's hands. */
    placeholderData: (previous) => previous,
    retry: false,
  });
}
